import { StyledOption } from '@fountain/fountain-ui-components';
import { Grid, Typography } from '@material-ui/core';
import classNames from 'classnames';
import React, { FC } from 'react';

import { useStyles } from './styles';

export type StageOptionData = {
  id: string;
  title: string;
  type: string;
  // eslint-disable-next-line camelcase
  stage_id: number;
  disabledMessage?: string;
};

export type StageOptionWithMessageProps = {
  innerProps: unknown;
  isDisabled: boolean;
  isFocused: boolean;
  isSelected: boolean;
  label: string;
  innerRef?: () => void;
  data: StageOptionData;
};

export const StageOptionWithMessage: FC<
  StageOptionWithMessageProps
> = props => {
  const {
    data,
    label,
    isDisabled,
    isFocused,
    isSelected,
    innerProps,
    innerRef,
  } = props;
  const styles = useStyles();

  if (isDisabled && data.disabledMessage) {
    return (
      <Grid
        ref={innerRef}
        alignItems="flex-start"
        className={classNames(styles.option, {
          focused: isFocused,
          inactive: isDisabled,
          selected: isSelected,
        })}
        container
        justify="space-between"
        {...(innerProps as object)}
      >
        <Grid item xs zeroMinWidth>
          <Typography
            className={styles.optionLabel}
            title={label}
            variant="body2"
            component="div"
          >
            {label}
          </Typography>
          <Typography
            className={classNames(styles.optionLabel, styles.optionMessage)}
            color="textSecondary"
            variant="body2"
            component="div"
          >
            {data.disabledMessage}
          </Typography>
        </Grid>
      </Grid>
    );
  }
  return (
    <StyledOption
      {...props}
      data={{
        id: Number(data.id),
        label,
        value: data.stage_id,
        disabledMessage: data.disabledMessage,
      }}
    />
  );
};
